import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import FormField from '../../../forms/FormField';

const normalizePhone = require('../../../../utils/normalizePhone').handler;
const required = value => value ? undefined : 'Required';

const relationshipOptions = [
    { value: 'Assistant', label: 'Assistant' },
    { value: 'Spouse', label: 'Spouse' },
    { value: 'Partner', label: 'Partner' },
    { value: 'Family Member', label: 'Family Member' },
    { value: 'Other', label: 'Other' }
  ];
const checkError = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { message } = json || {};

  if (!message) return;

  switch (message) {
    case 'Duplicate':
      return 'Duplicate';
    default:
      return 'Generic';
  }
};

const SecondaryContactForm = (
  {
    handleSubmit,
    submitting,
    errorSubmit,
    toggle
  }
) => {
  const formSubmitError = checkError(errorSubmit);

  return (
    <div className="row">
      <div className="col-md-6">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-6">
              <Field
                name="sc_name_first"
                label="First Name"
                type="text"
                component={FormField.Input}
                validate={[required]}
              />
            </div>
            <div className="col-6">
              <Field
                name="sc_name_last"
                label="Last Name"
                type="text"
                component={FormField.Input}
                validate={[required]}
              />
            </div>
            
            <div className="col-6">
              <Field
                name="sc_email"
                label="Email"
                type="text"
                component={FormField.Input}
                validate={[required]}
              />
              </div>
              <div className="col-6">
             <Field
               name="emailConfirmations"
               type="checkbox"
               component={FormField.Switch}
               label="Receive all order and shipment notifications"
             />
            </div>
            <div className="col-6">
              <Field
                name="relationship"
                label="Relationship"
                type="text"
                validate={[required]}
                menuPortalTarget={document.body}
                component={FormField.SelectReact}
                options={relationshipOptions}
              />
            </div>
            <div className="col-6">
              <Field
                name="sc_phone"
                label="Mobile Phone (optional)"
                type="text"
                component={FormField.Input}
                normalizeOnBlur={normalizePhone()}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-6">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={submitting}
              >
                Submit
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                onClick={() => toggle('secondary-contact')}
                disabled={submitting}
              >
                Cancel
              </button>
            </div>
          </div>
          {formSubmitError === 'Duplicate' &&
            <div className="form-row">
              <span style={{ color: 'red', marginLeft: '10px' }}>
                Email address is already in use.
              </span>
            </div>}
          {formSubmitError === 'Generic' &&
            <div className="form-row">
              <span style={{ color: 'red', marginLeft: '10px' }}>
                An error occured updating name and email.
              </span>
            </div>}
        </form>
      </div>
    </div>
  );
};

const formName = 'secondary-contact-form';

const mapState = state => {
  const {
    error,
    result
  } = state.postSecondaryContact.toJS();
    
  return {
    errorSubmit: error
  };
};

const form = reduxForm({ form: formName, enableReinitialize: true })(
  SecondaryContactForm
);
export default connect(mapState)(form);
